import { useNavigate } from 'react-router-dom';

export default function Comparison() {
  const navigate = useNavigate();

  const handleConsult = () => {
    navigate('/');
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* 標題區 */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">熱門專案比一比</h2>
          <div className="w-20 h-1 bg-gradient-to-r from-orange-500 to-orange-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            青創貸款 vs 信保基金，哪一個適合您？一次看懂申請門檻與優勢。
          </p>
        </div>

        {/* 桌面版比較表格 */}
        <div className="hidden md:block bg-white rounded-2xl border-2 border-gray-200 overflow-hidden mb-12 shadow-lg">
          {/* 表頭 */}
          <div className="grid grid-cols-1 md:grid-cols-3 bg-gradient-to-r from-gray-50 to-gray-100">
            <div className="p-6 border-b md:border-b-0 md:border-r border-gray-200">
              <h3 className="text-xl font-bold text-gray-900">比較項目</h3>
            </div>
            <div className="p-6 border-b md:border-b-0 md:border-r border-gray-200 bg-blue-50">
              <h3 className="text-xl font-bold text-blue-600">青年創業專案</h3>
            </div>
            <div className="p-6 border-b md:border-b-0 border-gray-200 bg-purple-50">
              <h3 className="text-xl font-bold text-purple-600">中小企業信保專案</h3>
            </div>
          </div>

          {/* 比較項目一：適用對象 */}
          <div className="grid grid-cols-1 md:grid-cols-3 border-b border-gray-200">
            <div className="p-6 bg-gray-50 border-b md:border-b-0 md:border-r border-gray-200">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-user-line text-xl text-orange-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900">適用對象</h4>
              </div>
            </div>
            <div className="p-6 border-b md:border-b-0 md:border-r border-gray-200">
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">負責人 18-45 歲</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">公司設立未滿 8 年</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">需完成 20 小時創業課程</span>
                </li>
              </ul>
            </div>
            <div className="p-6 border-b md:border-b-0 border-gray-200">
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">符合中小企業認定標準</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">通常建議設立滿 1 年以上</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">有 401 報表與財務報表</span>
                </li>
              </ul>
            </div>
          </div>

          {/* 比較項目二：最高額度 */}
          <div className="grid grid-cols-1 md:grid-cols-3 border-b border-gray-200">
            <div className="p-6 bg-gray-50 border-b md:border-b-0 md:border-r border-gray-200">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-money-dollar-circle-line text-xl text-orange-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900">最高額度</h4>
              </div>
            </div>
            <div className="p-6 border-b md:border-b-0 md:border-r border-gray-200">
              <div className="mb-3">
                <span className="inline-block bg-blue-100 text-blue-700 text-2xl font-bold px-4 py-2 rounded-lg">
                  1,800 萬元
                </span>
              </div>
              <p className="text-sm text-gray-600">
                （週轉性 + 資本性）
              </p>
            </div>
            <div className="p-6 border-b md:border-b-0 border-gray-200">
              <div className="mb-3">
                <span className="inline-block bg-purple-100 text-purple-700 text-lg font-bold px-4 py-2 rounded-lg">
                  視營收而定
                </span>
              </div>
              <p className="text-sm text-gray-600">
                （通常為年營收 50%-100%）
              </p>
            </div>
          </div>

          {/* 比較項目三：核心優勢 */}
          <div className="grid grid-cols-1 md:grid-cols-3 border-b border-gray-200">
            <div className="p-6 bg-gray-50 border-b md:border-b-0 md:border-r border-gray-200">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-star-line text-xl text-orange-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900">核心優勢</h4>
              </div>
            </div>
            <div className="p-6 border-b md:border-b-0 md:border-r border-gray-200">
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong className="text-blue-600">100萬以下免保人</strong></span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">最高可申請2年寬限</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">降低初期創業資金壓力</span>
                </li>
              </ul>
            </div>
            <div className="p-6 border-b md:border-b-0 border-gray-200">
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">解決無擔保品問題</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700"><strong className="text-purple-600">信保成數最高 9.5 成</strong></span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">提高銀行放款意願</span>
                </li>
              </ul>
            </div>
          </div>

          {/* 比較項目四：準備文件 */}
          <div className="grid grid-cols-1 md:grid-cols-3">
            <div className="p-6 bg-gray-50 border-b md:border-b-0 md:border-r border-gray-200">
              <div className="flex items-center">
                <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-file-list-3-line text-xl text-orange-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900">準備文件</h4>
              </div>
            </div>
            <div className="p-6 border-b md:border-b-0 md:border-r border-gray-200">
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-file-text-line text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">創業計畫書</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-file-text-line text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">輔導課程證明</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-file-text-line text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">設立登記文件</span>
                </li>
              </ul>
            </div>
            <div className="p-6 border-b md:border-b-0 border-gray-200">
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-file-text-line text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">近三年財報</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-file-text-line text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">401 / 403 報表</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-file-text-line text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-gray-700">營運計畫書</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 手機版比較卡片 */}
        <div className="md:hidden space-y-8 mb-12">
          {/* 比較項目一：適用對象 */}
          <div className="space-y-4">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-user-line text-xl text-orange-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900">適用對象</h4>
            </div>

            {/* 青年創業專案 */}
            <div className="bg-blue-50 rounded-xl border-2 border-blue-200 p-5">
              <h5 className="text-base font-bold text-blue-600 mb-3">青年創業專案</h5>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">負責人 18-45 歲</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">公司設立未滿 8 年</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">需完成 20 小時創業課程</span>
                </li>
              </ul>
            </div>

            {/* 中小企業信保專案 */}
            <div className="bg-purple-50 rounded-xl border-2 border-purple-200 p-5">
              <h5 className="text-base font-bold text-purple-600 mb-3">中小企業信保專案</h5>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">符合中小企業認定標準</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">通常建議設立滿 1 年以上</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-checkbox-circle-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">有 401 報表與財務報表</span>
                </li>
              </ul>
            </div>
          </div>

          {/* 比較項目二：最高額度 */}
          <div className="space-y-4">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-money-dollar-circle-line text-xl text-orange-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900">最高額度</h4>
            </div>

            {/* 青年創業專案 */}
            <div className="bg-blue-50 rounded-xl border-2 border-blue-200 p-5">
              <h5 className="text-base font-bold text-blue-600 mb-3">青年創業專案</h5>
              <div className="mb-2">
                <span className="inline-block bg-blue-100 text-blue-700 text-xl font-bold px-4 py-2 rounded-lg">
                  1,800 萬元
                </span>
              </div>
              <p className="text-sm text-gray-600">
                （週轉性 + 資本性）
              </p>
            </div>

            {/* 中小企業信保專案 */}
            <div className="bg-purple-50 rounded-xl border-2 border-purple-200 p-5">
              <h5 className="text-base font-bold text-purple-600 mb-3">中小企業信保專案</h5>
              <div className="mb-2">
                <span className="inline-block bg-purple-100 text-purple-700 text-base font-bold px-4 py-2 rounded-lg">
                  視營收而定
                </span>
              </div>
              <p className="text-sm text-gray-600">
                （通常為年營收 50%-100%）
              </p>
            </div>
          </div>

          {/* 比較項目三：核心優勢 */}
          <div className="space-y-4">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-star-line text-xl text-orange-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900">核心優勢</h4>
            </div>

            {/* 青年創業專案 */}
            <div className="bg-blue-50 rounded-xl border-2 border-blue-200 p-5">
              <h5 className="text-base font-bold text-blue-600 mb-3">青年創業專案</h5>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700"><strong className="text-blue-600">100萬以下免保人</strong></span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">最高可申請2年寬限</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">降低初期創業資金壓力</span>
                </li>
              </ul>
            </div>

            {/* 中小企業信保專案 */}
            <div className="bg-purple-50 rounded-xl border-2 border-purple-200 p-5">
              <h5 className="text-base font-bold text-purple-600 mb-3">中小企業信保專案</h5>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">解決無擔保品問題</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700"><strong className="text-purple-600">信保成數最高 9.5 成</strong></span>
                </li>
                <li className="flex items-start">
                  <i className="ri-arrow-right-s-fill text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">提高銀行放款意願</span>
                </li>
              </ul>
            </div>
          </div>

          {/* 比較項目四：準備文件 */}
          <div className="space-y-4">
            <div className="flex items-center mb-4">
              <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                <i className="ri-file-list-3-line text-xl text-orange-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900">準備文件</h4>
            </div>

            {/* 青年創業專案 */}
            <div className="bg-blue-50 rounded-xl border-2 border-blue-200 p-5">
              <h5 className="text-base font-bold text-blue-600 mb-3">青年創業專案</h5>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-file-text-line text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">創業計畫書</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-file-text-line text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">輔導課程證明</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-file-text-line text-blue-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">設立登記文件</span>
                </li>
              </ul>
            </div>

            {/* 中小企業信保專案 */}
            <div className="bg-purple-50 rounded-xl border-2 border-purple-200 p-5">
              <h5 className="text-base font-bold text-purple-600 mb-3">中小企業信保專案</h5>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <i className="ri-file-text-line text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">近三年財報</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-file-text-line text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">401 / 403 報表</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-file-text-line text-purple-600 mt-1 mr-2 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700">營運計畫書</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* CTA 按鈕區 */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <button 
            onClick={handleConsult}
            className="w-full sm:w-auto px-10 py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-full font-bold text-lg hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            諮詢青創專案
          </button>
          <button 
            onClick={handleConsult}
            className="w-full sm:w-auto px-10 py-4 bg-gradient-to-r from-purple-600 to-purple-700 text-white rounded-full font-bold text-lg hover:from-purple-700 hover:to-purple-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            諮詢信保專案
          </button>
        </div>
      </div>
    </section>
  );
}
